<div class="input-group">
  <input
    type="number"
    class="form-control"
    [formControl]="fromControl"
    [placeholder]="placeholderFrom" />
  <span class="input-group-text"> - </span>
  <input
    type="number"
    class="form-control"
    [formControl]="toControl"
    [placeholder]="placeholderTo" />
</div>
